import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Paragraph, Spinner } from "../../../../widgets";
import { ParagraphProperties, useParagraphProperties } from "./ParagraphProperties";

import { DraftParagraphComponent } from "./DraftParagraphComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const ParagraphComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useParagraphProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <Paragraph className={className} {...properties}>
        {children}
    </Paragraph>
}

Registry.addControl({
    id: "43e4f2ad-08c5-47ae-aae5-22c096bc2a9b",
    name: "Paragraph",
    type: ControlType.Paragraph,
    properties: ParagraphProperties,
    component: ParagraphComponent,
    draftComponent: DraftParagraphComponent
})
